export default {"src":"/_next/static/media/pool.cd6599c2.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};